<template>
    <div ref="scrollContainer" class="flex-1 px-4 py-4 border-gray-300 border-b overflow-y-scroll">
        <ul class="w-full space-y-2 max-h-0">
            <Message v-for="(message, i) in messages" :key="i" :message="message"></Message>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Message from './Message.vue'
export default {
    components: {
        Message
    },
    computed: {
        ...mapGetters({
            messages: 'getMessages',
        }),
        count() {
            if(! this.messages) return 0;
            return this.messages.length;
        }   
    },
    watch: {
        count: function() {
            this.scrollToBottom();
        }
    },
    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                this.$refs.scrollContainer.scrollTop = this.$refs.scrollContainer.scrollHeight;
            });
        },
    },
}
</script>
